<p>forgot-password-entry-point works!</p>
